module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "random-archives"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.videos), function(v) {
    return _c('router-link', {
      key: v.ytid,
      staticClass: "video",
      style: ({
        'background-image': 'url(' + v.thumbnail + ')'
      }),
      attrs: {
        "to": {
          name: 'video-player',
          params: {
            ytid: v.ytid
          }
        }
      }
    }, [_c('div', {
      staticClass: "overlay"
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('div', {
      staticClass: "title-bg"
    }, [_c('h4', {
      staticClass: "title"
    }, [_vm._v(_vm._s(v.title))])]), _vm._v(" "), _c('div', {
      staticClass: "note-bg"
    }, [_c('p', {
      staticClass: "note"
    }, [_vm._v(_vm._s(v.note))])])])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "random-archives-title-wrapper"
  }, [_c('h4', {
    staticClass: "random-archives-title"
  }, [_vm._v("RANDOM ARCHIVES")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-610c8b9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RandomArchives.vue
// module id = 86
// module chunks = 0